import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_HTTP_URL || '/portal-seguranca/';
export const REACT_URL_CONFIG = process.env.REACT_APP_URL_CONFIG || 'https://app-originar-security-portal-tst.azurewebsites.net/'
export const ID_MODULO_SEGURANCA = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
export const API_NOTIFICACOES_URL = process.env.REACT_APP_API_NOTIFICACOES_URL || 'https://originar-tst.amaggi.com.br/api';

export default axios.create({
    responseType: "json",
    baseURL: REACT_URL_CONFIG
});
